import { render, staticRenderFns } from "./ModuleTextForm.vue?vue&type=template&id=403a7b61&scoped=true"
import script from "./ModuleTextForm.vue?vue&type=script&lang=js"
export * from "./ModuleTextForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403a7b61",
  null
  
)

export default component.exports